export default {
  backHome: "← Zurück zur Startseite",
  articleNotFound: "Guide nicht gefunden.",
  moreGuides: "Entdecke weitere originale Kauf-Guides rund um das AllChinaBuy Spreadsheet.",
  browseGuides: "Alle Guides ansehen",
  published: "Veröffentlicht",
  updated: "Zuletzt aktualisiert",
  author: "Vom AllChinaBuy Spreadsheet-Team",
  readTime: "Min. Lesezeit",

  title: "AllChinaBuy Spreadsheet: Der Komplette Käufer-Guide",
  metaTitle: "AllChinaBuy Spreadsheet: Der Komplette Käufer-Guide (2026)",
  metaDescription: "Ein kompletter Guide zum AllChinaBuy Spreadsheet — Produkte finden, Verkäufer bewerten, QC-Fotos lesen und Versand wählen. Originale, käuferorientierte Tipps für klügeres Shoppen.",

  intro: "Das AllChinaBuy Spreadsheet ist zu einer beliebten Methode geworden, um Produktfunde zu organisieren, Verkäufer zu vergleichen und Qualitätskontrollen vor der Bestellung zu verfolgen. Dieser Guide erklärt, was das Spreadsheet ist, wie man es nutzt und wie man die häufigsten Fehler vermeidet — damit du mit besserer Information und weniger Rätselraten einkaufen kannst.",

  tocTitle: "Inhaltsverzeichnis",

  sections: [
    {
      id: "what-is",
      heading: "Was ist das AllChinaBuy Spreadsheet?",
      body: [
        "Das AllChinaBuy Spreadsheet ist ein strukturiertes Dokument, das Produktlinks, Verkäuferdetails, Qualitätskontroll-Notizen (QC) und Versandinformationen in einer einzigen Übersicht zusammenführt. Statt Dutzende Browser-Tabs offen zu halten, nutzen Käufer das Spreadsheet, um Artikel nebeneinander zu vergleichen und die zuverlässigsten Optionen zu erkennen.",
        "Ein typisches AllChinaBuy Spreadsheet gruppiert Artikel nach Kategorie — Schuhe, Hoodies, T-Shirts, Jacken, Taschen, Accessoires und mehr — und ergänzt dann Spalten für QC-Status, Verkäufer-Zuverlässigkeit, nützliche Notizen und das letzte Aktualisierungsdatum. Diese Struktur verwandelt eine unübersichtliche Linkliste in eine klare, filterbare Ressource.",
      ],
    },
    {
      id: "how-to-use",
      heading: "So nutzt du das Spreadsheet",
      body: [
        "Wähle zuerst eine Kategorie, die dich interessiert, und scanne dann die Zeilen nach Artikeln, die deinem Geschmack und Budget entsprechen. Achte auf die QC-Spalte — als verifiziert markierte Artikel haben meist bestätigte Fotos und Maße, während unmarkierte Artikel vor dem Kauf zusätzliche Recherche erfordern.",
        "Nutze die Verkäufer-Spalte, um zu prüfen, ob ein Verkäufer konsistente, zuverlässige Angebote hat. Auch das letzte Aktualisierungsdatum zählt: Informationen ändern sich schnell, also priorisiere kürzlich aktualisierte Zeilen.",
      ],
    },
    {
      id: "evaluate-sellers",
      heading: "So bewertest du Verkäufer",
      body: [
        "Ein guter Verkäufer hat in der Regel detaillierte Produktfotos, genaue Größentabellen und eine Historie konsistenter Angebote. Achte beim Vergleich von Verkäufern im AllChinaBuy Spreadsheet auf klare QC-Informationen und weniger Beschwerden über Größen- oder Materialabweichungen.",
        "Verlasse dich nicht auf ein einzelnes Angebot. Gleiche das Produkt wenn möglich über Kategorien hinweg ab und behandle fehlende Informationen als Anlass für Rückfragen — nicht als Grund, den Artikel zu überspringen.",
      ],
    },
    {
      id: "qc-photos",
      heading: "QC-Fotos richtig lesen",
      body: [
        "QC-Fotos sind dein bester Schutz vor Überraschungen. Achte auf Bilder, die das tatsächliche Produkt zeigen, nicht nur Studio-Renderings — prüfe Nähte, Logos, Etiketten, Farbgenauigkeit und Maße. Ein hilfreiches QC-Set enthält Nahaufnahmen von Details, die leicht falsch gemacht werden.",
        "Vergleiche QC-Fotos im Kontext des AllChinaBuy Spreadsheets mit dem ursprünglichen Angebot. Wenn etwas anders aussieht, bitte vor dem Versand um Klärung.",
      ],
    },
    {
      id: "shipping",
      heading: "Versand und Kosten",
      body: [
        "Die internationalen Versandkosten hängen vom Zielort, dem Paketgewicht und der gewählten Versandlinie ab. Schwerere Artikel wie Jacken und Schuhe kosten mehr im Versand, während leichte Accessoires und T-Shirts günstiger sind. Nutze die Versand-Guides im Spreadsheet, um die Kosten vor der Bestellung abzuschätzen.",
        "Die Lieferzeit variiert je nach Spediteur und Zielort. Schnellere Linien kosten mehr, kommen aber früher an; Economy-Linien sparen Geld, brauchen aber länger. Wähle je nach Dringlichkeit und Budget.",
      ],
    },
    {
      id: "mistakes",
      heading: "Häufige Fehler, die du vermeiden solltest",
      body: [
        "Einer der häufigsten Fehler ist, QC-Informationen zu ignorieren und blind zu bestellen. Ein anderer ist, die falsche Größe zu wählen, weil die Größentabelle übersprungen wurde. Beides lässt sich leicht vermeiden, wenn du die Notizen und QC-Felder des Spreadsheets konsequent nutzt.",
        "Auch das überstürzte Versenden ohne Prüfung der finalen QC-Fotos ist riskant. Nimm dir die Zeit, um zu bestätigen, dass alles stimmt — das ist weit günstiger, als ein Problem zu entdecken, nachdem das Paket das Lager bereits verlassen hat.",
      ],
    },
  ],

  ctaTitle: "Bereit, die organisierten Funde zu durchstöbern?",
  ctaDesc: "Weiter zur Hauptwebsite, um das vollständige AllChinaBuy Spreadsheet zu erkunden — nach Kategorie organisiert, mit QC- und Verkäuferinformationen.",
  ctaLabel: "AllChinaBuy Spreadsheet entdecken",
  buyLabel: "Jetzt kaufen",
  backLabel: "Zurück zum Ressourcencenter",
};